/**
 * Module courses — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "courses",
  label: "Courses",
  icon: "i-truck",
  navGroup: "operations",
  navOrder: 30,
  rolesRequis: [],
  routes: [{ path: "/courses", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
